<template>
  <div class="card-area">
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="md-layout-item md-size-50 md-small-size-100">
        <div class="md-title">Secure ID Verify</div>

        <md-card-header>
          <div class="md-title">Thanks James!</div>
        </md-card-header>
        <div class="md-title">
          Our systems will now review
          <br />
          your ID for authenticity.
          <br />
          Your SVID number will work
          <br />
          at participating web sites and
          <br />
          apps.
        </div>
        <md-card-content>
          <div>
            <input
              type="text"
              placeholder="Insert your YouTube URL here ..."
              disabled=true;
              v-model="message"
            />

            <button class="copy_button"
              type="button"
              v-clipboard:copy="message"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <img src="../assets/copy_icon.png"/>
            </button>
          </div>
        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending" />
        <div class="m-title">
          We have also emailed your
          <br />
          SVID to: {{message}}
        </div>
      </md-card>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";

export default {
  name: "RedirectSVID",
  props: {
    msg: String,
  },
  component: {},
  mixins: [validationMixin],
  data: () => ({
    form: {
      firstName: null,
      lastName: null,
      password: null,
    },
    message: "PWIWIDXUDEYSENPK",
    userSaved: false,
    sending: false,
    lastUser: null,
    phoneNumber: null,
    selectedDate: null,
  }),
  validations: {
    form: {
      firstName: {
        required,
        minLength: minLength(3),
      },
      lastName: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
    },
  },
  mounted() {},
  methods: {
    onCopy: function (e) {
      console.log("sadfS");
      alert("You just copied the following text to the clipboard: " + e.text);
    },
    onError: function (e) {
      alert("Failed to copy the text to the clipboard");
      console.log(e);
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    validateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveUser();
      }
    },
  },
};
</script>

<style lang="css" scoped>
/* .md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.copy_button{
  border:unset;
  width:35px;
  height: 35px;
}
.md-card-actions {
  flex-direction: column;
}
.md-card-actions .md-button {
  margin-top: 20px !important;
  padding: 10px;
}
.md-card {
  display: inline-block;
  padding: 20px;
}
.card-area {
  align-items: center;
  justify-content: center;
  background: #ddd;
}
.md-primary {
  background-color: green;
  color: white !important;
}
.md-layout-item.md-size-50 {
  min-width: 100%;
  max-width: 50%;
} */
</style>